import React from 'react'
import { useTranslation } from 'react-i18next'
import HomePageV2 from '@/components/LandingPageV2'
import { LandingPageV2Layout } from '@/components/LandingPageV2'

const IndexPage = () => {
  const { t } = useTranslation()

  return (
    <LandingPageV2Layout title={` - ${t('subtitles.tabText')}`}>
      <HomePageV2 />
    </LandingPageV2Layout>
  )
}

export default IndexPage
